// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8e889764","348":"361a8576","417":"f35e2d04","455":"0325d8ce","784":"30e417bc"}[chunkId] + ".chunk.js";
};